module.exports = __webpack_public_path__ + "img/goods2.86e12161.jpg";